import { createSelector } from '@app/utils/createSelector'

import type { ChatServerState } from '@app/packages/chat/state'
import { initialChatServerState } from '@app/packages/chat/state'

import { createReduxSlice } from '@app/store/redux_slice'

/**
 * The whole self-contained `@app/packages/chat` state mounted as a single slice
 * of the main store. Exported for this directory only — write through
 * `applyChatAction` (./actions), read through ./selectors.
 */
export const chatStateSlice = createReduxSlice<ChatServerState>('chat')

export const chatStateSelector = createSelector([chatStateSlice.selector], state => state ?? initialChatServerState)
